export const REGISTER = 'dt:device_type:register';
export const RECEIPT_PRINTER = 'dt:device_type:receipt_printer';
export const SERVICE_PRINTER = 'dt:device_type:service_printer';
export const CASH_DRAWER = 'dt:device_type:cash_drawer';
export const TYRO_TERMINAL = 'dt:device_type:tyro_terminal';
export const SPI_TERMINAL = 'dt:device_type:spi_terminal';
export const WINDCAVE_TERMINAL = 'dt:device_type:windcave_terminal';
export const FREEDOMPAY_TERMINAL = 'dt:device_type:freedompay_terminal';
export const AURUS_TERMINAL = 'dt:device_type:aurus_terminal';